// this file is just so the component is exported from the folder
// and there aren't several files named index.js open in dev env
//import TelematicsBoxList from './TelematicsBoxList';
import TelematicsBoxPage from './TelematicsBoxPage';

export default TelematicsBoxPage;
